const $ = jQuery

export default function Accordion () {
  const ACCORDIONS = document.querySelectorAll('.mtt-accordion__accordion-title')
  if (ACCORDIONS.length > 0) {
    for (let i = 0; i < ACCORDIONS.length; i++) {
      const ACCORDION = ACCORDIONS[i]
      ACCORDION.addEventListener('click', () => {
        $(ACCORDION.nextElementSibling).slideToggle(300)
        if (ACCORDION.parentNode.className === 'mtt-accordion__accordion') {
          ACCORDION.parentNode.className = 'mtt-accordion__accordion active'
        } else {
          ACCORDION.parentNode.className = 'mtt-accordion__accordion'
        }
      })
    }
  }
}
